/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
function addDeleteForms() {
    $('[data-method]').append(function () {
        if (!$(this).find('form').length > 0) {
            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                '</form>\n';
        } else { return '' }
    })
        .attr('href', '#')
        .attr('style', 'cursor:pointer;')
        .attr('onclick', '$(this).find("form").submit();');
}




function initSendMessagePage() {


    $('.message-recipients #select_all').click(function () {
        $('.user-toggle,.condo-toggle').attr('checked', $(this).is(':checked'));
    });

    $(document).on('change', '.condo-toggle', function () {
        let condoID = $(this).attr('data-condo-id');
        let checkBoxes = $('.user-toggle[data-condo-id=' + condoID + ']');
        checkBoxes.prop("checked", $(this).prop("checked"));
    });


}


/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        $(this).find('input[type="submit"]').attr('disabled', true);
        $(this).find('button[type="submit"]').attr('disabled', true);
        return true;
    });

    /**
     * Generic confirm form delete using Sweet Alert
     */
    $('body')
        .on('submit', 'form[name=delete_item]', function (e) {
        e.preventDefault();

        let form = this;
        let link = $('a[data-method="delete"]');
        if (link.length  === 0) {
            link = $('a[data-method]');
        }
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Yes, delete';
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to delete this item?';

        swal({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            type: 'warning'
        }).then((result) => {
            result.value && form.submit();
        });
    }).on('click', 'a[name=confirm_item]', function (e) {
        /**
         * Generic 'are you sure' confirm box
         */
        e.preventDefault();

        const link = $(this);
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

        swal({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            type: 'info'
        }).then((result) => {
            result.value && window.location.assign(link.attr('href'));
        });
    })

        .on('click', '.view-comment-link', function () {

        let id = $(this).attr('data-comment-id');
        let apiViewEndpoint = document.getElementById('comment-admin-component').getAttribute('data-api-view');
        let url = apiViewEndpoint.replace('9999', id);

        axios.get(url).then(function (response) {
            //      console.log(response);

            if (typeof response.data.ok !== 'undefined') {
                let modalWindow = jQuery("#comment-view-modal");
                modalWindow.find('.created_by').text(response.data.full_name);


                let dateObj = new Date(response.data.created_at);
                dateObj.toLocaleString('en-US', { timeZone: 'America/Edmonton' });
                modalWindow.find('.created_at').text( dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString());


                modalWindow.find('.contents').text(response.data.created_at);
                modalWindow.find('.title').text(response.data.title);
                modalWindow.find('.content').text(response.data.details);


                jQuery("#comment-form-modal").modal('hide');
                modalWindow.modal('show');
            } else {
                alert('Error finding comment');
            }
        });

    });


    if ($('#create-notification-form').length !== 0) {
        initSendMessagePage();
    }

});
